// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3ja-l","icon":"SortAdornment_icon__Ofn2Y","up":"SortAdornment_up__3bnz7","down":"SortAdornment_down__1iLzS","active":"SortAdornment_active__1ofCK"};